module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [(_vm.banner.slider) ? _c('div', [_c('i-banner', {
    attrs: {
      "sliders": _vm.banner.slider,
      "height": "514px"
    },
    on: {
      "changeLang": _vm.changeLang
    }
  }, [_c('div', {
    staticClass: "baoming"
  }, [_c('iButton', {
    attrs: {
      "text": _vm.bmText,
      "icon-class": "fa-pencil"
    },
    on: {
      "buttonBind": _vm.toggle
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.navs && _vm.banner.slider) ? _c('div', {
    staticStyle: {
      "height": "50px",
      "margin-top": "-25px"
    }
  }, [_c('i-nav', {
    attrs: {
      "navs": _vm.navs,
      "author": _vm.author
    },
    on: {
      "login": _vm.login
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.lanmu), function(item, index) {
    return _c('div', [(item.name && !item.baseInfo) ? _c('div', [_c('top-bar', {
      staticStyle: {
        "padding": "12px 0 12px 12px",
        "border-bottom": "1px solid #ababab",
        "margin-top": "32px"
      },
      attrs: {
        "id": item.id,
        "text": item.name
      }
    }), _vm._v(" "), (item.defHtml) ? _c('div', {
      staticClass: "box-list",
      domProps: {
        "innerHTML": _vm._s(item.defHtml)
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.name && item.baseInfo) ? _c('div', {
      attrs: {
        "id": item.id
      }
    }, [_c('base-info', {
      attrs: {
        "language": _vm.language,
        "baseInfos": _vm.baseInfos,
        "oProvince": _vm.oProvince
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.teacher) ? _c('div', [_c('i-teacher', {
      attrs: {
        "dataInfo": _vm.teachers,
        "col": "4",
        "spanCol": "6"
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.news.length > 0) ? _c('div', [_c('i-news', {
      attrs: {
        "news": item.news
      }
    })], 1) : _vm._e()])
  })), _vm._v(" "), (_vm.banner.slider) ? _c('i-brand') : _vm._e(), _vm._v(" "), _c('i-scan', {
    attrs: {
      "activeScan": _vm.activeScan
    },
    on: {
      "scanClick": _vm.toggle
    }
  }), _vm._v(" "), _c('i-login', {
    attrs: {
      "language": _vm.language,
      "flag": _vm.showLogin
    },
    on: {
      "closeLogin": _vm.closeLogin,
      "loginUser": _vm.loginUser
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9dad62e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = 830
// module chunks = 10